import { ReactElement } from 'react';
import { QRCodeSVG } from 'qrcode.react';

import { InputTypes } from '@cashier/cashier-model';
import { isStringBase64 } from '@cashier/cashier-shared';

import styles from './styles.module.scss';

interface QrCodeProperties {
  value: string;
  type: 'square' | 'rectangle';
  behaviourType: 'redirect' | 'image';
}

export const QrCode = ({
  value,
  type,
  behaviourType,
}: QrCodeProperties): ReactElement => {
  const imageSource = isStringBase64(value)
    ? `data:image/png;base64,${value}`
    : value;

  return (
    <div className={styles.wrapper}>
      {behaviourType === 'redirect' ? (
        <QRCodeSVG
          value={value}
          className={styles[type]}
          data-test="qrCode"
          includeMargin
        />
      ) : (
        <img
          src={imageSource}
          alt={InputTypes.QrCode}
          className={styles[type]}
          data-test="qrCode"
        />
      )}
    </div>
  );
};
